import { apiClient } from 'pobble-components/dist/api'

export const apiCreateMedium = (id, data, params) => {
  const formData = new FormData()
  Object.keys(data).forEach(key => formData.append(key, data[key]))
  return apiClient.post(`/v3/works/${id}/media`, formData, {
    params
  })
}

export const apiDeleteMedia = id => apiClient.delete(`/v3/media/${id}`)

export const apiGetWork = (id, params) =>
  apiClient.get(`/v3/works/${id}`, { params })

export const apiDeleteWork = id => apiClient.delete(`/v3/works/${id}`)

export const apiRotateMedium = (id, data, params) =>
  apiClient.put(`/v3/media/${id}/rotate`, data, { params })

export const apiUpdateWork = (id, data, params) =>
  apiClient.put(`/v3/works/${id}`, data, { params })

export const apiReorderMedia = (id, data) =>
  apiClient.put(`/v3/works/${id}/reorder_media`, data)
